module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "builder__select-option"
  }, [_c('div', {
    staticClass: "builder__select-option-name"
  }, [_c('label', {
    attrs: {
      "for": _vm.domId
    }
  }, [_vm._v(_vm._s(_vm.option.display_title ? _vm.option.display_title : _vm.option.title) + ":")])]), _vm._v(" "), _c('div', {
    staticClass: "builder__select-option-choice"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selection),
      expression: "selection"
    }],
    staticClass: "builder__select-option-choice-input",
    attrs: {
      "id": _vm.domId
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selection = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v(_vm._s(_vm.option.is_required ? '--CHOOSE--' : ''))]), _vm._v(" "), _vm._l((_vm.option.choices), function(choice) {
    return _c('option', {
      domProps: {
        "value": choice.id
      }
    }, [_vm._v("\n        " + _vm._s(choice.title) + "\n        " + _vm._s(choice.price_adjustment_text) + "\n      ")])
  })], 2)]), _vm._v(" "), (_vm.option.help_text) ? _c('div', {
    staticClass: "builder__step-note"
  }, [_vm._v("\n    " + _vm._s(_vm.option.help_text) + "\n  ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0aee0fe4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/option-types/Select.vue
// module id = 364
// module chunks = 0